var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-col min-h-screen"},[_c('div',{staticClass:"mx-auto container px-4 md:px-6 flex-1"},[_c('UpdateUserForm')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }